module.exports = __webpack_public_path__ + "static/media/nav-kn.6e0f231f.svg";